import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import contactImg2 from '../../../../assets/rsto/contactImg2.png'
import "./ReachUs.css";

const ReachUs = () => {
  return (
    <div className='reachus py-md-5'>
      <Row className="gx-0 d-flex justify-content-center align-items-center">
        <Col xs={11} md={7} className='py-5 p-md-5'>
          <div className='reachus-content big_fonts_opti ques-article'>
            <h1>Vous avez des questions ?</h1>
            <p>Utilisez le formulaire ci-dessous pour entrer en contact avec l'équipe commerciale</p>
            <form action="">
              <div className='d-flex flex-column flex-md-row mb-3'>
                <input className='reachus-content-input me-0 mb-3 mb-md-0 me-md-3' type="text" placeholder='Nom*' />
                <input className="reachus-content-input" type="email" placeholder='E-mail*' />
              </div>
              <textarea className='reachus-content-input' type="text" placeholder='Zone de texte*' />
              <button className='animated-button victoria text-capitalized pt-md-3 ques-sub' >Soumettre</button>
            </form>
          </div>
        </Col>
        <Col xs={11} md={5} className='pb-5 p-md-5 d-flex justify-content-center align-items-center'>
          <img className='img-fluid' src={contactImg2} alt="" />
          {/* <img className='img-fluid' src="http://demo2.themelexus.com/delicioz/wp-content/uploads/2022/08/contact_img-1.jpg" alt="" /> */}
        </Col>
      </Row>
    </div>
  );
};

export default ReachUs;